import type { FC } from "react";

import { TranscriptionSectionContent } from "@/pages/audio-recordings/components";
import { AudioRecordingObservable } from "@/store/audio-recordings";

type Props = {
  recording?: AudioRecordingObservable;
};

export const InfoTranscriptionSection: FC<Props> = ({ recording }) => (
  <TranscriptionSectionContent recording={recording} />
);
